import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "ngx-change-pay-curent-year-month",
  templateUrl: "./change-pay-curent-year-month.component.html",
  styleUrls: ["./change-pay-curent-year-month.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangePayCurentYearMonthComponent extends BaseFormComponent<any> {
  public apiName: string = "MonthlySalaryCalculationInformation/ChangePayCurentYearMonth";
  public label: string = "تغییر ماه سیستم حقوق";
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.model = {};
    this.setColumns();
  }
  async setColumns() {
    this.columns = [];
    this.columns.push(<form_control>{
      label: "سال",
      controlType: FormControlTypes.textbox,
      modelName: "IssueYear",
      disabled: true,
      name: "IssueYear",
      order: 0,
      textType: "number",
      columnNumber: 1,
      formVisible: true,
      listVisible: true,
      required: true,
    });
    this.columns.push(<form_control>{
      label: "ماه جاری",
      controlType: FormControlTypes.dropdown,
      modelName: "IssueMonth",
      userClass: "select-shr",
      disabled: true,
      name: "IssueMonth",
      order: 2,
      textType: "number",
      columnNumber: 2,
      formVisible: true,
      listVisible: true,
      required: true,
      apiName: "MonthsName",
      valueMember: "Id",
      displayMember: "Title",
    });
    this.orignalColumns = this.columns;
    this.model.IssueYear = this.accountService.authService.getHrmPayCurentYearMonth().CurentYear;
    this.model.IssueMonth = this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth;
    this.setFormGroup(this.model);
    this._save();
  }
  public saveSuccessHelper(row?: any) {
    this.isClosing = false;
    this.submitted = true;
    this.selectorService.submitted$.next(this.submitted);
    this.showValidationErrors = false;
    this.selectorService.submitted$.next(false);
  }

  protected saveFailedHelper(error: any) {
    this.submitted = false;
    this.selectorService.submitted$.next(this.submitted);
    this.isClosing = false;
    this.isSaving = false;
    this.model.IssueYear = this.accountService.authService.getHrmPayCurentYearMonth().CurentYear;
    this.model.IssueMonth = this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth;
    this.sts.showDialog(`خطای ذخیره تغییرات: ${Utilities.getHttpResponseMessage(error)}`, "پیغام خطا");
    setTimeout(() => {
      this.model.IssueYear = this.accountService.authService.getHrmPayCurentYearMonth().CurentYear;
      this.model.IssueMonth = this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth;
    }, 200);
    this.setFormGroup(this.model);
  }

  _save() {
    if (this.formGroup.get("IssueYear").value && this.formGroup.get("IssueMonth").value) {
      this.httpCommonService
        .get<any>(
          `MonthlySalaryCalculationInformation/ChangePayCurentYearMonth/${this.formGroup.get("IssueYear").value}/${
            this.formGroup.get("IssueMonth").value
          }`
        )
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data) => {
            this.accountService.authService.saveHrmPayCurentYearMonth();
            this.saveSuccessHelper();
          },
          (error) => this.saveFailedHelper(error)
        );
    }
  }
  prevMonth() {
    if (this.formGroup.get("IssueMonth").value === 1) {
      this.formGroup.get("IssueYear").setValue(this.formGroup.get("IssueYear").value - 1);
      this.formGroup.get("IssueMonth").setValue(12);
    } else this.formGroup.get("IssueMonth").setValue(this.formGroup.get("IssueMonth").value - 1);
    this._save();
  }
  nextMonth() {
    if (this.formGroup.get("IssueMonth").value === 12) {
      this.formGroup.get("IssueYear").setValue(this.formGroup.get("IssueYear").value + 1);
      this.formGroup.get("IssueMonth").setValue(1);
    } else this.formGroup.get("IssueMonth").setValue(this.formGroup.get("IssueMonth").value + 1);
    this._save();
  }
  async save() {
    this.close();
  }
}
